import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { CardFeedCard } from 'src/queries/cardFeeds/cardFeeds.models'

/**
 * Resolves the cards the user has actually selected for bulk assignment from a
 * MUI X row-selection model. MUI X 8 models selection as the object form
 * `{ type, ids }`:
 * - `include` → the named ids are selected.
 * - `exclude` → everything EXCEPT the named ids is selected. This is what the
 *   header "select all" checkbox emits.
 *
 * Resolution is scoped to `visibleCards` (the rows currently rendered in the
 * grid), so "select all" while a search/status filter is active never pulls in
 * cards the user can't see. Only UNASSIGNED cards are assignable.
 */
export const resolveSelectedCards = (
  visibleCards: CardFeedCard[],
  selectionModel: GridRowSelectionModel,
): CardFeedCard[] => {
  const { ids, type } = selectionModel
  const isExclude = type === 'exclude'
  return visibleCards.filter(
    (card) =>
      card.status === 'UNASSIGNED' &&
      (isExclude ? !ids.has(card.id) : ids.has(card.id)),
  )
}
